import { FC, HTMLProps } from 'react';
import { getCampaignLink } from 'modules/campaignIndex/utils';
import { CampaignPreviewThumbnail } from 'modules/campaigns/lib/components/CampaignPreviewThumbnail';
import { messageMediumMap, campaignTypeMapWithEligibility } from 'modules/campaignIndex/constants';
import { Campaign } from 'modules/campaignIndex/types/Campaign';
import { colors } from 'ui/theme';
import { TruncateTooltip } from 'ui/utility/truncate/TruncateTooltip';
import { Open16 } from 'ui/icons';
import { Link } from 'ui/links';
import {
  StyledCampaignsListItem,
  StyledContributionsCampaignsList,
  StyledDirectionalityLegendWrapper,
  StyledDivider,
  StyledFlex,
  StyledFlexColumn,
  StyledLinkWrapper,
  StyledPreviewThumbnail,
  StyledSecondaryCaption,
  StyledCampaignMetaData,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/ContributionByCampaigns.style';
import { DirectionalityLegend } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/DirectionalityLegend';
import { CampaignWithDirectionality } from 'modules/intelligentInsights/brandAffinityInsights/types';
import { BrandAffinityLevel } from 'modules/domains';

export interface ContributionsByCampaignsProps {
  previewThumbnailsByIdData: any;
  fiteredByDirectionalityCampaignData: CampaignWithDirectionality[];
  selectedAffinityTab: BrandAffinityLevel;
}

export const ContributionCampaignList = ({
  previewThumbnailsByIdData,
  fiteredByDirectionalityCampaignData,
  selectedAffinityTab,
}: ContributionsByCampaignsProps) => {
  return (
    <StyledContributionsCampaignsList>
      {fiteredByDirectionalityCampaignData?.map((campaign, index) => {
        const campaignLink = getCampaignLink(campaign as unknown as Campaign);
        return (
          <div key={`${campaign.id}-${campaign.direction}`}>
            <StyledCampaignsListItem>
              <StyledFlex>
                <StyledPreviewThumbnail>
                  <CampaignPreviewThumbnail
                    campaign={campaign as unknown as Campaign}
                    previewThumbnail={previewThumbnailsByIdData[campaign.templateId]}
                  />
                </StyledPreviewThumbnail>
                <StyledFlexColumn>
                  <StyledLinkWrapper>
                    <TruncateTooltip
                      link={campaignLink}
                      LinkComponent={
                        Link as FC<React.PropsWithChildren<HTMLProps<HTMLAnchorElement>>>
                      }
                      maxWidth={300}
                      name={campaign.name}
                    />
                    <Open16 color={colors.iconInteractive} />
                  </StyledLinkWrapper>
                  <StyledCampaignMetaData>
                    <StyledSecondaryCaption>
                      {messageMediumMap[campaign.messageMedium]}
                    </StyledSecondaryCaption>
                    <StyledSecondaryCaption>
                      {campaignTypeMapWithEligibility[campaign.campaignTypeDefinition]}
                    </StyledSecondaryCaption>
                    <StyledSecondaryCaption>{`ID: ${campaign.id}`}</StyledSecondaryCaption>
                  </StyledCampaignMetaData>
                </StyledFlexColumn>
              </StyledFlex>
              <StyledDirectionalityLegendWrapper>
                <DirectionalityLegend
                  key={campaign.id}
                  directionality={campaign.direction}
                  cohort={selectedAffinityTab}
                />
              </StyledDirectionalityLegendWrapper>
            </StyledCampaignsListItem>
            {index !== fiteredByDirectionalityCampaignData.length - 1 && <StyledDivider />}
          </div>
        );
      })}
    </StyledContributionsCampaignsList>
  );
};
